<ng-container *ngIf="viewModel$|async as viewModel">
  <ng-container *ngFor="let project of viewModel.projects; trackBy:identity">
    <ng-container *ngIf="project">
      <div class="row">
        <div class="col-12 my-4">
          <p class="font-weight-bold">
            Project {{ project.index + 1 }}
          </p>
        </div>
        <div class="col-12">
          <table class="table project-table">
            <thead>
              <tr>
                <th class="code-column">Code</th>
                <th class="category-column">{{ viewModel.level }}</th>
                <th class="black-header quantity-column">Quantity</th>
                <th class="black-header unit-column">Unit</th>
                <th class="grey-header unit-rate-column">Unit Rate ({{ viewModel.currency }})</th>
                <th class="black-header total-cost-column">Total cost today ({{ viewModel.currency }})</th>
                <th class="black-header depreciated-cost-column">Depreciated cost ({{ viewModel.currency }})</th>
                <th class="black-header depreciated-per-unit-column">Per Unit ({{ viewModel.currency }})</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let record of project.records; let i = index">
                <ng-container *ngIf="record.kind === 'header' && !record.is_hidden">
                  <tr>
                    <td>{{ record.code }}</td>
                    <td [attr.colspan]="4" class="category-label" [ngStyle]="{'background-color': record.background_color}">
                      <div>
                        {{ record.category }}
                      </div>
                    </td>
                    <td>
                      {{ record.total_cost | mask:'separator.2':{thousandSeparator:','} }}
                    </td>
                    <td>
                      {{ record.depreciated_cost | mask:'separator.2':{thousandSeparator:','} }}
                    </td>
                    <td>
                      {{ record.depreciated_per_unit | mask:'separator.2':{thousandSeparator:','} }}
                    </td>
                  </tr>
                </ng-container>
                <ng-container *ngIf="record.kind === 'value' && !record.is_hidden">
                  <tr [ngClass]="{'row-removed': record.is_removed}">
                    <td class="has-overlay">
                      {{ record.code }}
                    </td>
                    <td class="has-overlay" [ngStyle]="{'background-color': record.background_color}">
                      <div>
                        <span>{{ record.category }}</span>
                      </div>
                    </td>
                    <td class="has-overlay">
                      {{ record.quantity | mask:'separator.2':{thousandSeparator:','} }}
                    </td>
                    <td class="has-overlay">
                      {{ record.unit_selected }}
                    </td>
                    <td class="has-overlay">
                      {{ record.unit_rate | mask:'separator.2':{thousandSeparator:','} }}
                    </td>
                    <td class="has-overlay">
                      {{ record.total_cost | mask:'separator.2':{thousandSeparator:','} }}
                    </td>
                    <td class="has-overlay">
                      {{ record.depreciated_cost
                            ? (record.depreciated_cost | mask:'separator.2':{thousandSeparator:','}) 
                            : 'N/A'
                      }}
                    </td>
                    <td class="has-overlay">
                      {{ record.depreciated_per_unit 
                            ? (record.depreciated_per_unit | mask:'separator.2':{thousandSeparator:','}) 
                            : 'N/A'
                      }}
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
              <tr>
                <td [attr.colspan]="5">
                  Total
                </td>
                <td>
                  {{ project.total.cost | mask:'separator.2':{thousandSeparator:','} }}
                </td>
                <td>
                  {{ project.total.depreciated_cost | mask:'separator.2':{thousandSeparator:','} }}
                </td>
                <td>
                  {{ project.total.depreciated_per_unit | mask:'separator.2':{thousandSeparator:','} }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <table class="table total-table">
    <tbody>
      <ng-container *ngFor="let project of viewModel.projects">
        <ng-container *ngIf="project">
          <tr>
            <td>Total (Project {{ project.index + 1 }})</td>
            <td>
              <ng-container *ngIf="project.total.depreciated_cost">
                {{ project.total.depreciated_cost | mask:'separator.2':{thousandSeparator:','} }} ({{ viewModel.currency }})
              </ng-container>
              <ng-container *ngIf="!project.total.depreciated_cost">
                <strong>Please complete all depreciation calculations</strong>
              </ng-container>
            </td>
          </tr>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!viewModel.usedLandInput">
        <tr>
          <td>Land Value</td>
          <td>
            {{ viewModel.landInputTotal | mask:'separator.2':{thousandSeparator:','} }} ({{ viewModel.currency }})
          </td>
        </tr>
      </ng-container>
      <tr>
        <td>Target Property Value</td>
        <td>
          <ng-container *ngIf="viewModel.total">
            {{ viewModel.total | mask:'separator.2':{thousandSeparator:','} }} ({{ viewModel.currency }})
          </ng-container>
          <ng-container *ngIf="!viewModel.total">
            <strong>Please complete all depreciation calculations</strong>
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table>
</ng-container>